import React from 'react'
import { Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer'
import {
  CGV,
  CustomerAddress,
  DocumentDate,
  Footer,
  Header,
  Payment,
  style,
  Subject,
  TableBody,
  TableHead,
  TableTotal
} from '../../document/DocumentPDF'
import { baseDocument } from '../../../utils/constants/misc'

const OrderPDF = ({ order_param: order, company_param: company, settings, logo_param: img }) => {
  const customer = order.customer
  const styles = StyleSheet.create(style)

  const References = () => {
    if (order) {
      return (
        <>
          <View style={[styles.rightContainer, { marginTop: 20 }]}>
            <View style={[styles.rightContainer, { marginTop: 10 }]}>
              <Text style={styles.boldWithSpace}>Référence commande</Text>
              <Text style={styles.address}>{order.order_number}</Text>
            </View>
          </View>
          <View style={[styles.rightContainer]}>
            {order.quote_id !== null && (
              <View style={styles.rightContainerNoMT}>
                <Text style={styles.boldWithSpace}>Référence devis</Text>
                <Text style={styles.address}>{order.quote.quote_number}</Text>
              </View>
            )}
          </View>
        </>
      )
    }
  }

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <View fixed>
          <Header styles={styles} title={'BON DE COMMANDE'} img={img} />
          <References />
          <DocumentDate date={order.order_date} styles={styles} />
        </View>
        <View>
          <CustomerAddress styles={styles} company={company} customer={customer} />
          <Subject styles={styles} document={order} />
        </View>
        <View fixed>
          <TableHead styles={styles} headers={baseDocument} />
        </View>
        <View>
          <TableBody headers={baseDocument} lines={order.lines} styles={styles} />
          <TableTotal total={order.total_amount_net} styles={styles} company={company} />
          <Payment customer={customer} settings={settings} styles={styles} />
        </View>

        <Footer company={company} styles={styles} />
      </Page>
      <CGV customer={customer} company={company} styles={styles} />
    </Document>
  )
}

export default React.memo(OrderPDF)
